import { useOutletContext } from "react-router-dom";
import { ApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

export const usePrivatePageContext = () => {
  return useOutletContext<{
    logout: () => void;
    user: DataSchema.AuthUser;
    apiClient: ApiClient;
  }>();
};
